"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withResult = void 0;
const index_1 = require("./index");
const utils_1 = require("./utils");
/**
 * @desc Function which wraps another function and returns a new function that has the same argument types as the wrapped function.
 * This new function will return a Fail result if the wrapped function throws an error, and returns an Ok result if the wrapped function does not.
 * @param fn The wrapped function
 * @param fnContext (optional) the context to execute the wrapped function in (for e.g. if it's a class method and needs the instance's properties to function)
 *
 * @example

 const { data: bufferFromUTF, error } = withResult(Buffer.from)([], "utf-8");
 if (error) {
   return ResultIs.failure(error);
 }
 console.log(bufferFromUTF);

 */
const withResult = (fn, fnContext) => (...args) => {
    try {
        const data = fnContext ? fn.apply(fnContext, args) : fn(...args);
        if ((0, utils_1.isPromise)(data)) {
            return data
                .then(value => (0, index_1.ok)(value))
                .catch(e => (0, index_1.err)(e));
        }
        return (0, index_1.ok)(data);
    }
    catch (error) {
        const e = error instanceof Error ? error : new Error("Unknown error");
        return (0, index_1.err)(e);
    }
};
exports.withResult = withResult;
